export default "__VITE_ASSET__db09649c__"